import React, { useState, useEffect } from "react"
import _ from 'lodash'
import { field_attrs } from "components/table/lib/column-field"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput, DropdownInput } from "components/table/carousel/inputs"

const Amount = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const emptyRecord = {
    amt: null,
    amttype: null,
    inflationdetail: null
  }
  const [data, setData] = useState<object|null>(props.rowData)
  const inflationOptions = _.map(
    _.get(props, "namedItems.inflation"),
    item => {
      return {value: item.inflationid, label: item.code}
    }
  )
  let inflationMappedCode = "*Departmental"
  const inflationDefault = _.get(_.find(inflationOptions, o => o.label === inflationMappedCode), "value")

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val: number, field: string):void {
    let localCache = _.cloneDeep(data);
    let nextData = _.cloneDeep(props.rowData)

    if(_.isNull(_.get(nextData, "amttype"))) _.set(nextData, "amttype", props.defaults['amttype'])

    _.set(nextData, "inflationdetail", {
      inflationMode: "namedItem",
      inflationNamedItemId: inflationDefault
    })

    if(field === "inflationdetail.inflationNamedItemId") {
      nextData["inflationdetail"] = localCache["inflationdetail"] = {
        inflationMode: "namedItem",
        inflationNamedItemId: val
      }
    } else {
      nextData[field] = localCache[field] = val
    }
    setData(localCache)

    nextData["lineitemdetail"] = {state: "basic"}
    nextData["inputtype"] = "amt"
    nextData["areaid"] = null

    props.persist(nextData, props.field, props.rowData)
  }

  const attrs = (field) => field_attrs('lineitem')(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Amt</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="amt" readPrecision={2} writePrecision={2} trailingZeros={false} persist={updateData} />
        </div>
        <div>
          <label>Amt Type</label>
          <DropdownInput className="automated" data={data} attrs={attrs} default={props.defaults['amttype']}
            field="amttype" options={['Per Mo', 'Per Yr']} persist={updateData} />
        </div>
        <div>
          <label>Inflation</label>
          <DropdownInput className="automated" data={data} attrs={attrs} field="inflationdetail.inflationNamedItemId" options={inflationOptions} persist={updateData} default={inflationDefault} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default Amount
